<template>
  <div>
    <div
      v-if="isExpanded"
      class="tw-fixed tw-top-0 tw-left-0 tw-bg-black tw-opacity-30 tw-w-full tw-h-full tw-z-[51]"
    ></div>
    <div
      class="tw-fixed tw-right-0 tw-top-0 tw-z-[52] tw-w-full tw-h-full tw-max-w-0 tw-bg-white tw-overflow-y-auto tw-overflow-x-hidden tw-transition-all tw-duration-300 tw-ease-in-out"
      :class="{ 'tw-max-w-[600px] tw-shadow-lg ': isExpanded }"
    >
      <div class="tw-absolute tw-top-6 tw-right-2 tw-z-30">
        <IconButton
          class="tw-w-10 tw-h-10 tw-items-center tw-justify-center tw-flex"
          @click="onClose"
          ><img :src="CloseIcon"
        /></IconButton>
      </div>
      <div :class="{ 'tw-hidden': !isExpanded }">
        <v-tabs v-model="tabIndex">
          <div class="tw-hidden">
            <v-tooltip bottom :disabled="!mailDisabled" max-width="15rem">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-tab
                    dense
                    class="d-flex flex-column tab"
                    :disabled="
                      mailDisabled || isInCalibration || isDiabledRightSide
                    "
                    @click.prevent="select(0)"
                  >
                    <v-icon :color="$vuetify.theme.themes.light.primaryDark"
                      >mdi-email-outline</v-icon
                    >
                    <span id="tab-label1" class="tab-label">Mail</span>
                  </v-tab>
                </div>
              </template>
              <span>You don't have permissions to perform this action</span>
            </v-tooltip>
            <v-tab
              dense
              class="d-flex flex-column mt-8"
              :disabled="
                isInCalibration || iscurrentGolive || isDiabledRightSide
              "
              @click.prevent="select(1)"
            >
              <v-icon :color="$vuetify.theme.themes.light.primaryDark"
                >mdi-comment-text-multiple-outline</v-icon
              >
              <span id="tab-label2" class="tab-label">Chat</span>
            </v-tab>
            <v-tab
              dense
              class="d-flex flex-column mt-8"
              :disabled="
                isInCalibration || iscurrentGolive || isDiabledRightSide
              "
              @click.prevent="select(2)"
            >
              <v-icon :color="$vuetify.theme.themes.light.primaryDark"
                >mdi-clipboard-edit-outline</v-icon
              >
              <span id="tab-label3" class="tab-label">Notes</span>
            </v-tab>
            <v-tab
              dense
              class="d-flex flex-column mt-8"
              :disabled="
                isInCalibration || iscurrentGolive || isDiabledRightSide
              "
              @click.prevent="select(3)"
            >
              <v-icon :color="$vuetify.theme.themes.light.primaryDark"
                >mdi-history</v-icon
              >
              <span id="tab-label4" class="tab-label">History</span>
            </v-tab>
            <div v-if="!isFullSize">
              <v-btn
                icon
                width="41px"
                height="41px"
                color="#6B7280"
                class="full-size-btn"
                :disabled="isDiabledRightSide"
                @click="isFullSize = true"
              >
                <v-icon class="pr-1" size="17px">fas fa-chevron-left</v-icon>
              </v-btn>
            </div>
            <div>
              <v-btn
                icon
                width="41px"
                height="41px"
                color="#6B7280"
                class="full-size-btn"
                @click="isFullSize = false"
              >
                <v-icon size="17px">fas fa-chevron-right</v-icon>
              </v-btn>
            </div>
          </div>
          <v-tabs-items v-model="tabItem">
            <template>
              <div
                v-if="isDiabledRightSide"
                class="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-white tw-z-20 tw-opacity-70"
              ></div>
              <div class="loader-box" :class="{ 'disp-block': loading }"></div>
              <v-tab-item>
                <div
                  v-if="candidates.length"
                  class="tw-h-screen tw-overflow-auto"
                >
                  <TabMail
                    v-show="!isInCalibration"
                    :isFullSize="isFullSize"
                    :candidates="candidates"
                    :projectId="projectId"
                    :tab="tab"
                    :calendarSetupNeeded="calendarSetupNeeded"
                    :showFakeCard="showFakeCard"
                    :isCalibration="isCalibration"
                    v-on="$listeners"
                    @loading2="$emit('loading2', $event)"
                    @changecalibration="$emit('changecalibration', $event)"
                  />
                </div>
              </v-tab-item>
              <v-tab-item>
                <div class="tw-h-screen tw-overflow-auto">
                  <TabChat
                    v-if="candidates.length"
                    :isFullSize="isFullSize"
                    :candidates="candidates"
                    :projectId="projectId"
                    :tab="tab"
                    v-on="$listeners"
                  />
                </div>
              </v-tab-item>
              <v-tab-item>
                <div class="tw-h-screen tw-overflow-auto">
                  <NotesV2
                    v-if="candidates.length"
                    :isFullSize="isFullSize"
                    :candidates="candidates"
                    :projectId="projectId"
                    :tab="tab"
                    @onSaveNote="select(0)"
                    v-on="$listeners"
                  />
                </div>
              </v-tab-item>
              <v-tab-item>
                <div class="tw-h-screen tw-overflow-auto">
                  <History
                    v-if="candidates.length"
                    :isFullSize="isFullSize"
                    :candidates="candidates"
                    :projectId="projectId"
                    :tab="tab"
                    v-on="$listeners"
                  />
                </div>
              </v-tab-item>
            </template>
          </v-tabs-items>
        </v-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from '@/assets/icons/close-icon.svg';
import IconButton from '@/components/v3/base/IconButton';
import TabMail from './TabMail';
import TabChat from './TabChat';
import NotesV2 from './NotesV2';
import History from './History';

const ROLES = {
  Admin: 1,
  Editor: 2,
  Commenter: 3,
};

export default {
  components: {
    TabMail,
    TabChat,
    NotesV2,
    History,
    IconButton,
  },

  props: {
    candidates: Array,
    expanded: { type: Boolean, default: true },
    projectId: String,
    tab: String,
    currentUserRole: Number,
    calendarSetupNeeded: Boolean,
    loading: Boolean,
    isCalibration: Boolean,
    iscurrentGolive: Boolean,
    isShowIntro: Boolean,
    showFakeCard: Boolean,
    isDiabledRightSide: Boolean,
  },

  data() {
    // const tabIndex = this.expanded ? 1 : 0;
    const tabIndex = 0;
    return {
      tabIndex,
      tabItem: tabIndex,
      mailDisabled: false,
      isFullSize: false,
      CloseIcon,
      isExpanded: false,
    };
  },

  computed: {
    isOpen() {
      return this.tabIndex > 0;
    },

    selectedProject() {
      return (
        this.$store.getters['projects/getProjectById'](this.projectId) || {}
      );
    },

    isPilot() {
      return (
        this.selectedProject.in_auto_swipe_mode || // TODO(jeremiah): delete this line after v2 migration.
        this.selectedProject.type === '1'
      );
    },

    isSelfServe() {
      return this.selectedProject.type === '3';
    },

    isInCalibration() {
      // TODO(jeremiah): clean this up after v2 rollout
      if (this.$store.getters['user/getIsUserV2']) {
        return this.isCalibration;
      }
      return (this.isPilot || this.isSelfServe) && this.isCalibration;
    },
  },

  watch: {
    loading(status) {
      if (!status) {
        const tab = this.currentUserRole === ROLES.Commenter ? 1 : 0;
        this.tabItem = tab;
      }
    },
  },

  created() {
    switch (this.currentUserRole) {
      case ROLES.Admin:
        this.mailDisabled = false;
        break;
      case ROLES.Editor:
        this.mailDisabled = false;
        break;
      case ROLES.Commenter:
        this.mailDisabled = true;
        this.tabIndex = 1;
        this.tabItem = 1;
        break;
      default:
        this.mailDisabled = false;
    }

    this.$eventHub.$on('open-history', () => {
      this.tabIndex = 3;
      this.tabItem = 3;
    });
    this.$eventHub.$on('open-mail', () => {
      if (this.currentUserRole === ROLES.Commenter) return;

      this.tabIndex = 0;
      this.tabItem = 0;
    });
  },

  methods: {
    select(tabIndex) {
      if (this.tabIndex !== tabIndex) {
        this.tabIndex = tabIndex;
        this.tabItem = tabIndex;
      } else {
        // this.tabIndex = 0;
      }
    },

    onOpen(val) {
      this.select(val);
      this.isExpanded = true;
    },

    onClose() {
      this.isExpanded = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';
.side-panel {
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  z-index: 10;
  &::v-deep {
    .v-tabs-bar__content {
      min-height: 700px;
    }
  }
}
.side-panel::v-deep .v-tabs-bar {
  flex: 0 0 48px;
  z-index: 11;
}

.side-panel .tab-items {
  flex: 1 1 auto;
}
.side-panel::v-deep .v-slide-group__wrapper {
  -webkit-box-shadow: 3px -3px 12px -8px rgba(0, 0, 0, 0.5);
  box-shadow: 3px -3px 12px -8px rgba(0, 0, 0, 0.5);
}

.side-panel::v-deep .v-tabs-bar__content {
  width: 3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.side-panel::v-deep .v-tabs-slider-wrapper {
  display: none;
}

.side-panel::v-deep .v-tab {
  width: 3rem;
  min-width: 3rem;
  height: 60px !important;
  margin: 6px 0;
  padding: 4px 0;
  color: $primary-dark;

  &.v-tab--active {
    background-color: $itemSelected;

    i::before {
      color: $primary-dark;
    }
    span {
      color: $primary-dark;
    }
  }
  span {
    margin-top: 4px;
    letter-spacing: normal;
  }
}

.side-panel {
  transition: 0.5s;
  box-shadow: -4px 0 8px -3px rgba(0, 0, 0, 0.1),
    -2px 0 6px -2px rgba(0, 0, 0, 0.05);
  max-width: 288px;
  width: 100%;
  &.none-expanded {
    width: auto;
    .v-tab.v-tab--active {
      color: #0073bf;
      background: none;
    }
    .v-tab.v-tab--active i::before,
    .v-tab.v-tab--active span {
      color: #0073bf;
    }
  }
}

.hidden-tab {
  max-height: 0;
}

.tab-items {
  max-height: 100%;
  box-shadow: -4px 0 8px -3px rgba(0, 0, 0, 0.1),
    -2px 0 6px -2px rgba(0, 0, 0, 0.05);
}

.tabs-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.side-panel-container {
  background-color: #ffffff;
  display: flex;
  min-width: 3rem;
}

.side-panel-tabs {
  background-color: #dddddd;
  flex: 0 0 3rem;
}

.side-panel-contents {
  max-width: 0;
  transition: max-width 0.5s;
}

.side-panel-contents.expanded {
  width: 16rem;
  max-width: 16rem;
}

.tab-button {
  width: 3rem;
  height: 4rem;
  opacity: 0.55;
  padding: 0.5rem;
}

.tab-button.active {
  background-color: #37b797;
  opacity: 1;
}

.tab-icon {
  width: 2rem;
  height: 2rem;
}

.tab-text {
  font-size: 0.8rem;
  text-align: center;
  color: #000000;
}
.active .tab-text {
  color: #ffffff;
}

.tab-label {
  font-size: 12px;
  text-transform: capitalize;
  color: $primary-dark;
}
.full-size-btn {
  background-color: $scrollbar-color;
  margin-left: 2.4px;
  margin-top: 70px;
}
.full-size {
  max-width: 563px !important;
}
.loader-box {
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  opacity: 0.3;
  display: none;
}
.disp-block {
  display: block;
}
.overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.15);
  z-index: 2;
}
.z-10 {
  z-index: 10;
}
.z-1 {
  z-index: 0;
}
::v-deep {
  .v-tabs-bar {
    height: auto;
  }
  .v-slide-group__content {
    display: none;
  }
}
</style>
